import styled from 'styled-components'
import { Alert } from '@sainsburys-tech/bolt'

const SizeAlert = styled(Alert)`
  margin-top: 0;
  padding: 10px;
`

const SizePickerHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const SelectSizePickerWrapperABTest = styled.div`
  ${({ isTuTestVariant, theme }) =>
    isTuTestVariant &&
    `
      @media (max-width: ${theme.size.breakpoint['max-width'].sm}) {
        display: none;
      }
    `}
`

export { SizeAlert, SizePickerHeader, SelectSizePickerWrapperABTest }
